var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2592 25.7411C24.4014 25.7411 15.6792 25.7411 6.64062 25.7411C6.7988 23.7074 6.70841 21.6737 7.16034 19.753C7.61227 17.8549 9.21662 16.9737 11.1373 16.7929C11.5892 16.7477 12.0412 16.7929 12.4931 16.7703C13.9845 16.6799 15.1143 16.7703 16.1311 18.4198C18.097 21.5833 22.8874 21.041 24.5822 17.6742C24.9437 16.9285 25.3504 16.7025 26.1187 16.7477C26.9322 16.7929 27.7682 16.7477 28.6043 16.7703C31.1577 16.8381 33.0558 18.5554 33.2366 21.0862C33.327 22.5776 33.2592 24.0915 33.2592 25.7411Z",
    fill: "#333D6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8493 5.33663C20.7873 5.83375 19.7704 6.26308 18.7536 6.7602C18.1209 7.07655 17.4656 7.3929 16.9007 7.79963C14.8896 9.31359 14.7992 11.4828 16.6069 13.1776C16.8555 13.4035 17.1267 13.6069 17.3978 13.8329C14.9348 13.4713 12.6978 10.1045 12.8107 6.98616C12.9237 3.37074 15.8613 0.320231 19.4315 0.0264777C23.1147 -0.289872 26.5268 2.26352 27.2272 5.81115C27.9051 9.33619 25.9392 12.929 22.5272 14.0136C24.0411 12.9516 24.945 11.7088 25.1258 10.0819C25.1484 9.78811 24.9902 9.2684 24.7868 9.17801C22.9339 8.52272 21.9849 7.23472 21.8493 5.33663Z",
    fill: "#333D6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 29H37C37.5523 29 38 29.4477 38 30V39V41H40V39V30C40 28.3431 38.6569 27 37 27H3C1.34315 27 0 28.3431 0 30V39V41H2V39V30C2 29.4477 2.44772 29 3 29Z",
    fill: "#333D6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.555cc05c183416f3432b2128750b7247.svg";
export { ForwardRef as ReactComponent };